import React from 'react';
import {
	BottomNavigation,
	BottomNavigationAction,
	Paper,
	Tooltip,
	Typography,
	AppBar,
	Toolbar,
	IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';
import CloseIcon from '@material-ui/icons/Close';
import { useActions, useValues } from 'kea';
import { assetinfowindowlogic } from 'src/store/global';

import HistoryPanel from './Tabs/history';
import InfoPanel from './Tabs/Info';
import profilelogic from 'src/store/profile';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<>
					{children}
				</>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};


const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 0,
		flexGrow: 1,
		minWidth: 200
	},
	limitHeight: {
		// minHeight:35,
	},
	BottomNavigation: {
		marginTop: "16px",
	},
	TabPanel: {

	},
	title: {
		flexGrow: 1,
		display: 'none',
		[theme.breakpoints.up('sm')]: {
			display: 'block',
		},
	},

}));

export default function TrackerInfoWindow() {
	const classes = useStyles();

	const { asset } = useValues(assetinfowindowlogic);
	const { set } = useActions(assetinfowindowlogic);
	const { profile } = useValues(profilelogic);

	const [value, setValue] = React.useState(0);

	const handleClose = () => {
		set(null);
	}

	if (!asset) {
		return null;
	}
	return (
		<Rnd
			default={{
				x: 600,
				y: 500,
				width: 550,
			}}
			enableResizing={false}
			bounds={"#panelHolder"}
			disableDragging={false}
			cancel={
				"#rnd-ignore-drag"
			}
		>
			<Paper className={classes.root} style={{ maxWidth: 550, maxHeight: 500 }}>
				<div style={{
					flexGrow: 1,
				}}>
					<AppBar className="handle cursor" position="static">
						<Toolbar variant="dense">
							<Typography className={classes.title} variant="h6" noWrap>
								{`${asset.type} - ${asset.color} - ${asset.name}`}
							</Typography>
							<div id={'rnd-ignore-drag'}>
								<Tooltip title='Close'>
									<IconButton onClick={handleClose} aria-label="less" className={classes.margin} >
										<CloseIcon htmlColor='white' />
									</IconButton>
								</Tooltip>
							</div>
						</Toolbar>
					</AppBar>
				</div>

				<div id={'rnd-ignore-drag'} className={classes.root} style={{ cursor: 'default' }}>
					<TabPanel value={value} index={0} >
						<InfoPanel asset={asset} />
					</TabPanel>
					<TabPanel value={value} index={1}>
						<HistoryPanel asset={asset} />
					</TabPanel>
					{/* <TabPanel value={value} index={2}>
						<ReplayPanel asset={asset} />
					</TabPanel> */}
					<BottomNavigation
						value={value}
						onChange={(event, newValue) => {
							setValue(newValue);
						}}
						showLabels
						className={classes.BottomNavigation}
					>
						<BottomNavigationAction label="Information" icon={<HistoryIcon />} />
						<BottomNavigationAction label="Movement History" icon={<InfoIcon />} />
						{/* <BottomNavigationAction label="Replay Route" icon={<ReplayIcon />} /> */}
					</BottomNavigation>
				</div>
			</Paper>
		</Rnd>
	);
}
